import * as IncomingTopicsActions from './actions';
import { IncomingTopicsSto, RelatedObjectSto } from '../models/incoming-topic.model';

export interface IncomingTopicsPageResult {
  loadedAt: Date | null;
  totalCount: number;
  topics: IncomingTopicsSto[];
  related: RelatedObjectSto[];
  limit: number;
  offset: number;
}
export interface IncomingTopicsState {
  // pageLoading and pageResult will be available for different
  // viewIds such as IncomingTopicList, MachineDetails, CustomerDetails
  pageLoading: Map<string, boolean>;
  pageResult: Map<string, IncomingTopicsPageResult>;
  detailsLoading: boolean;
  detailsLoadedAt: Date | null;
  detailsResult: {
    topic: IncomingTopicsSto | null;
    related: RelatedObjectSto[];
  };
}

export const initialState: IncomingTopicsState = {
  pageLoading: new Map<string, boolean>(),
  pageResult: new Map<string, IncomingTopicsPageResult>(),
  detailsLoading: false,
  detailsLoadedAt: null,
  detailsResult: null,
};

export function reducer(state = initialState, action: IncomingTopicsActions.Actions): IncomingTopicsState {
  switch (action.type) {
    case IncomingTopicsActions.LOAD_PAGE: {
      const loadPageLoadingMap: Map<string, boolean> = Object.assign({}, state.pageLoading);
      loadPageLoadingMap[action?.payload?.viewId] = true;
      return {
        ...state,
        pageLoading: loadPageLoadingMap,
      };
    }
    case IncomingTopicsActions.LOAD_PAGE_FAILURE: {
      const loadPageFailureLoadingMap: Map<string, boolean> = Object.assign({}, state.pageLoading);
      loadPageFailureLoadingMap[action?.payload?.viewId] = false;
      return {
        ...state,
        pageLoading: loadPageFailureLoadingMap,
      };
    }
    case IncomingTopicsActions.LOAD_PAGE_SUCCESS: {
      const loadPageSuccessLoadingMap: Map<string, boolean> = Object.assign({}, state.pageLoading);
      loadPageSuccessLoadingMap[action?.payload?.viewId] = false;

      const newPageResult: IncomingTopicsPageResult = {
        loadedAt: new Date(),
        totalCount: action?.payload?.topicsTotalCount,
        topics: action?.payload?.topics,
        related: action?.payload?.related,
        limit: action?.payload?.viewFilter.pageSize,
        offset: action?.payload?.offset,
      };
      const loadPageSuccessResultMap: Map<string, IncomingTopicsPageResult> = Object.assign({}, state.pageResult);
      loadPageSuccessResultMap[action?.payload?.viewId] = newPageResult;

      return {
        ...state,
        pageLoading: loadPageSuccessLoadingMap,
        pageResult: loadPageSuccessResultMap,
      };
    }
    case IncomingTopicsActions.LOAD_DETAILS:
      return {
        ...state,
        detailsLoading: true,
        detailsLoadedAt: null,
        detailsResult: null,
      };

    case IncomingTopicsActions.LOAD_DETAILS_FAILURE:
      return {
        ...state,
        detailsLoading: false,
        detailsLoadedAt: null,
        detailsResult: null,
      };

    case IncomingTopicsActions.LOAD_DETAILS_SUCCESS:
      return {
        ...state,
        detailsLoading: false,
        detailsLoadedAt: new Date(),
        detailsResult: {
          topic: action?.payload?.topic,
          related: action?.payload?.related,
        },
      };

    default:
      return state;
  }
}

export const pageLoading = (state: IncomingTopicsState) => state?.pageLoading;
export const pageResult = (state: IncomingTopicsState) => state?.pageResult;

export const detailsLoading = (state: IncomingTopicsState) => state?.detailsLoading;
export const detailsLoadedAt = (state: IncomingTopicsState) => state?.detailsLoadedAt;
export const detailsResult = (state: IncomingTopicsState) => state?.detailsResult;
